import { BaseError } from '@belimo-retrofit-portal/logic';
import { SagaIterator } from 'redux-saga';
import { sentryCatch } from 'src/modules/config/utils/sentryCatch';
import { call } from 'typed-redux-saga';

export function* unknownErrorHandler(error: BaseError): SagaIterator<void> {
  yield* call(sentryCatch, error);
}
